import React from 'react';
import PropTypes from 'prop-types';
import Filter, { FilterModal, FilterSection } from './Filter';
import RadioFilter from './FilterComponents/CoreComponents/RadioFilter';
import { getUpdatedAgeTagsForPlayerSearch } from '../../../utils/search';
import styles from '../search.scss';

const PlayerAgeTagsFilter = (props) => {
    const { filters, filterInputs, handleFilterClick, filterModal, closeModals, handleFilterSubmit, searchTypes, handleFilterUpdate, mobileOnly, desktopOnly, 'data-testid': dataTestId } = props;
    const ageTags = searchTypes?.ageTags ? searchTypes.ageTags : [];
    const labelMappings = {
        6: '12 & under',
        7: '14 & under',
        8: '16 & under',
        9: '18 & under',
        10: '19-22',
        11: '20-29',
        12: '30-34',
        13: '35-39',
        14: '40-44',
        15: '45-49',
        16: '50-59',
        17: '60-69',
        18: '70+',
    };
    const updatedAgeTags = getUpdatedAgeTagsForPlayerSearch(ageTags);
    const remappedHighlightedLabel = labelMappings[updatedAgeTags.find(option => option.label === filters.ageTag)?.id] || 'Age Division';
    const remappedOptions = updatedAgeTags.map(tag => {
        if (labelMappings[tag.id]) {
            return {
                ...tag,
                description: labelMappings[tag.id],
            };
        }
        return tag;
    });

    return (
        <div className={styles.filterWrapper}>
            <Filter
                filterName={'ageTags'}
                handleFilterClick={handleFilterClick}
                isActive={filters?.ageTag || filterModal === 'ageTags'}
                mobileOnly={mobileOnly}
                desktopOnly={desktopOnly}
                data-testid={dataTestId}
            >
                {remappedHighlightedLabel}
            </Filter>
            {filterModal === 'ageTags' && (
                <FilterModal
                    title={'Age Division'}
                    handleFilterSubmit={handleFilterSubmit}
                    onCloseClick={closeModals}
                    data-testid={dataTestId}
                >
                    <FilterSection>
                        <RadioFilter
                            name="ageTag"
                            options={remappedOptions}
                            selected={filterInputs.ageTag}
                            onChange={(ageTag) => {
                                handleFilterUpdate({ ageTag });
                            }}
                            data-testid={dataTestId && `${dataTestId}.options`}
                        />
                    </FilterSection>
                </FilterModal>
            )}
        </div>
    );
};

PlayerAgeTagsFilter.propTypes = {
    filters: PropTypes.instanceOf(Object),
    mobileOnly: PropTypes.bool,
    desktopOnly: PropTypes.bool,
    handleFilterUpdate: PropTypes.func,
    // searchTypes is an object dict ({ ageTags: [...], ... }); body uses
    // optional chaining so it's not strictly required.
    searchTypes: PropTypes.shape({}),
    handleFilterSubmit: PropTypes.func,
    closeModals: PropTypes.func,
    filterModal: PropTypes.string.isRequired,
    handleFilterClick: PropTypes.func,
    filterInputs: PropTypes.shape({}).isRequired,
    'data-testid': PropTypes.string,
};

PlayerAgeTagsFilter.defaultProps = {
    filters: {},
    searchTypes: {},
    mobileOnly: false,
    desktopOnly: false,
    handleFilterUpdate: () => { },
    handleFilterSubmit: () => { },
    closeModals: () => { },
    handleFilterClick: () => { },
    'data-testid': null,
};

export default PlayerAgeTagsFilter;
